import * as React from 'react';

export class FixedDocument extends React.Component<any> {

  public componentDidMount() {
    if (document) {
      document.body.style.overflow = 'hidden';
    }
  }

  public componentWillUnmount(){
    if (document){
      document.body.style.overflow = '';
    }
  }

  public render() {
    return this.props.children;
  }
}
